<script>
  import { page } from '$app/stores';
  import { linkify } from '$utils';
  import Button from './Button.svelte';
  import Notification from './Notification.svelte';
  // biome-ignore lint/suspicious/noGlobalAssign: TODO: Fix this lint rule
  $: ({ error, status } = $page);
  const errors = [
    {
      status: 500,
      description:
        "We're sorry, we seem to have experienced a server error. Please try again later, or reach out to us at hello@colosseum.org.",
    },
    {
      status: 404,
      description: 'Looks like the resource you are looking for is not available.',
    },
    // TODO add more relevant errors
  ];
</script>

<div class="flex min-h-[calc(100vh_-_4rem)] w-full items-center justify-center">
  <Notification
    negative
    title={`${status} - ${error?.message}`}
    description={linkify(
      errors.find((error) => error.status === status)?.description || errors[0].description,
    )}
  >
    <div class="flex items-center justify-between gap-x-6">
      <Button secondary href="/">Go home</Button>
      <Button quinary href="/support">Contact support</Button>
    </div>
  </Notification>
</div>
